<template>
  <div class="meu-primeiro-livro">
    <Navbar/>
    <!-- MENU DESTAQUE -->
    <div class="menu-destaque">
      <div class="container hide-sm">
        <div class="row">
          <div class="col-md-3 p-0">
            <router-link to="/meu-primeiro-livro">
              <div class="box-destaque rosa">
                <span class="">Meu Primeiro Livro</span>
              </div>
            </router-link>
          </div>
          <div class="col-md-3 p-0">
            <router-link to="/ed-infantil-1">
              <div class="box-destaque verde-escuro">
                <span class="">Ed. Infantil 1</span>
              </div>
            </router-link>
          </div>
          <div class="col-md-3 p-0">
            <router-link to="/ed-infantil-2">
              <div class="box-destaque laranja-escuro">
                <span class="">Ed. Infantil 2</span>
              </div>
            </router-link>
          </div>
          <div class="col-md-3 p-0">
            <router-link to="/ed-infantil-3">
              <div class="box-destaque vermelho">
                <span class="">Ed. Infantil 3</span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
            <div class="col">
              <div class="duvidas">
                <a href="http://www.editoradobrasil.com.br/faleconosco/" target="_blank" rel="noopener noreferrer">DÚVIDAS ? FALE CONOSCO</a>
              </div>
            </div>
        </div>
      </div>
    </div>
    <!-- BANNER -->
    <div class="container">
      <div class="row">
        <div class="banner-mpl ef3">
          <div class="col-md-8 offset-md-2">
            <div class="texto-mpl">
              <h2>Ed. Infantil 3</h2>
              <p>- Linguagem</p>
              <p>- Matemática</p>
              <p>- Natureza e sociedade</p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="tabs">
              <div class="list-group" id="myList" role="tablist">
                <a class="btn btn-tab btn-tab-vermelho active" data-toggle="list" href="#livro" role="tab">Ed. Infantil 3</a>
                <a class="btn btn-tab btn-tab-vermelho" data-toggle="list" href="#comp" role="tab">Complementares</a>
              </div>

              <div class="tab-content">
                <div class="tab-pane fade show active" id="livro" role="tabpanel">
                    <div class="row justify-content-around">
                        <div class="col-md  text-center md-right">
                            <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/mitanga/linguagem-ei3/index.html" target="_blank" rel="noopener noreferrer">
                                <img src="../assets/imgs/ed-3/mit-ling-3.png" class="img-fluid">
                            </a>
                        </div>
                        <div class="col-md  text-center md-center">
                            <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/mitanga/matematica-ei3/index.html" target="_blank" rel="noopener noreferrer">
                                <img src="../assets/imgs/ed-3/mit-mat-3.png" class="img-fluid">
                            </a>
                        </div>
                        <div class="col-md  text-center md-left">
                            <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/mitanga/natureza-e-sociedade-ei2/index.html" target="_blank" rel="noopener noreferrer">
                                <img src="../assets/imgs/ed-3/mit-nat-3.png" class="img-fluid">
                            </a>
                        </div>
                    </div>
                  <div class="legenda">
                    <h5>Legenda:</h5>
                    <p><img src="../assets/icons/book2.png" class="img-fluid"> Contém Versão Digital</p>
                  </div>
                </div>
                <div class="tab-pane fade text-center" id="comp" role="tabpanel">
                  <div class="row justify-content-center">
                    <div class="col-md-10">
                      <VueSlickCarousel v-bind="settings">
                        <div class="">
                          <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/mitanga/complementos/mitanga-em-familia/3/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/imgs/ed-3/complementares/MIV0_capa_familia_3_mercado_PF.png" class="img-fluid mx-auto vertical-align"></a>
                        </div>
                        <div class="">
                          <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/mitanga/complementos/mitanga-em-atividade/3/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/imgs/ed-3/complementares/MI_AT_3_capa_LA_mercado_2021_PF_0001.png" class="img-fluid mx-auto vertical-align"></a>
                        </div>
                        <div class="">
                          <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/mitanga/complementos/mitanga-em-festa/3/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/imgs/ed-3/complementares/MI_FE_3_capa_LA_mercado_2021_PF.png" class="img-fluid mx-auto vertical-align"></a>
                        </div>
                        <div class="">
                          <a href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/mitanga/complementos/mitanga-em-jogos/3/index.html" target="_blank" rel="noopener noreferrer"><img src="../assets/imgs/ed-3/complementares/MI_MJ_3_capa_LA_mercado_2021_PF.png" class="img-fluid mx-auto vertical-align"></a>
                        </div>
                        <div class="">
                          <a data-toggle="modal" data-target="#modal3"><img src="../assets/imgs/ed-3/complementares/mitanga-ed3.png" class="img-fluid mx-auto vertical-align"></a>
                        </div>
                      </VueSlickCarousel>
                    </div>
                  </div>
                  <!-- MODAL -->
                  <div class="modal fade" id="modal3" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <img src="../assets/imgs/ed-3/complementares/modal-ed3.png" class="img-fluid">
                          </div>
                        </div>
                      </div>
                    </div>
                  <div class="legenda">
                    <h5>Legenda:</h5>
                    <p><img src="../assets/icons/book2.png" class="img-fluid"> Contém Versão Digital</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'Ed-infantil-3',
  components: {
    Navbar,
    Footer,
    VueSlickCarousel
  },
  data() {
    return {
      settings: {
          "arrows": true,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "initialSlide": 0,
          "touchMove": false,
          "responsive": [
              {
              "breakpoint": 1024,
              "settings": {
                  "slidesToShow": 3,
                  "slidesToScroll": 1
                  }
              },
              {
              "breakpoint": 600,
              "settings": {
                  "slidesToShow": 2,
                  "slidesToScroll": 1,
                  "centerMode": true,
                  "touchMove": true
                  }
              },
              {
              "breakpoint": 480,
              "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "centerMode": true,
                  "touchMove": true
                  }
              }
          ]
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .vermelho {
    background-color: #EE5A46;
    color: #fff;
  }
</style>